/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   MessagingModal Selectors
 */

import { MODAL_TYPE, type State } from '@zcode/state-type'
import { compose } from 'redux'
import { selectModals, selectOpen } from '../index'

export const selectMessageModalOpen = (state: State) => selectOpen(state, MODAL_TYPE.MESSAGE)

const selectMessageModal = compose((state) => state.message, selectModals)

export const selectMessagingModalData = compose((state) => state.data, selectMessageModal)

export const selectMessagingModalMeta = compose((state) => state.meta, selectMessageModal)

export const selectMessageModalStep = compose((state) => state.step, selectMessageModal)

export const selectEntity = compose((state) => state.entity, selectMessagingModalData)

export const selectCtaName = compose((state) => state.ctaName, selectMessagingModalData)
